import { APIS } from '@/constants';
import { apisUtility } from '@/utils';
import axios from 'axios';

const bankApi = {
  /**
   *
   * @param {String} token
   * @param {String} type
   * @returns {AxiosPromise}
   */
  requestBalance(token, type) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = apisUtility.bindValuedParams({
      token_type: type,
    });
    return axios({
      url: '/balance',
      method: 'get',
      baseURL: APIS.BASE_URL.BANK,
      headers,
      params,
    });
  },
};

export default bankApi;
